import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Modal, Button, Table, Form } from 'react-bootstrap';
//import { logFrameData as localData } from '../constants/logFrameDataConstants';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css'; // Import custom CSS for sticky header
import { APP_API_URL } from '../constants/appURLConstrants';
import api from '../utils/apiHelper'; // Use the centralized API helper with token handling
import { hasRole } from '../utils/authHelper'; // Import the hasRole function

export default function LogFrame() {

    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [editedData, setEditedData] = useState({});
    const [hasChanges, setHasChanges] = useState(false); //track if there are unsaved changes in the modal

    //Constant for logframe modal metadata updates for baseline / mid-term / end target
    const [showMetaModal, setShowMetaModal] = useState(false);
    const [metaData, setMetaData] = useState([]);
    const [editedMeta, setEditedMeta] = useState({});
    const [hasMetaChanges, setHasMetaChanges] = useState(false);

    //Constant for logframe modal questionnaire results updates for each year
    const [showQuestionnaireModal, setShowQuestionnaireModal] = useState(false);
    const [questionnaireData, setQuestionnaireData] = useState([]);
    const [editedQuestionnaire, setEditedQuestionnaire] = useState({});
    const [hasQuestionnaireChanges, setHasQuestionnaireChanges] = useState(false);



    // Mapping of group index to label indicator to show whether(Outcome/Output/blank by default) for better readability in the table
    const groupIndicatorLabelMap = {
        6: "Outcome",
        7: "Outcome",
        8: "Outcome",
        9: "Outcome",
        10: "Outcome",
        11: "Output",
        12: "Output",
        13: "Output",
        14: "Output",
        15: "Output",
        16: "Output",
        17: "Outcome",
        19: "Output",
        20: "Output",
        21: "Output",
        22: "Output",
        23: "Outcome",
        24: "Output"
    };







    const fetchData = async () => {
        try {
            const response = await api.get('/api/logframe/getLogframeData');
            setData(response.data);
        } catch (error) {
            console.error('Error fetching logframe data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (!data || data.length === 0) return <p>Loading...</p>;

    //const years = Object.keys(data[0]?.yearlyData ?? {}).sort(); // auto-detect years from data
    //const years = ["2023", "2024-current", "2024", "2025", "2026", "2027", "2028", "2029", "2030"]; // Manually set years to match modified data structure as requested by user
    const years = ["2024", "2025", "2026", "2027", "2028", "2029", "2030"]; // (Removed 2023 and 2024-current) Manually set years to match modified data structure as requested by user
    const totalColumns = 6 + years.length * 3; // 6 fixed columns + 3 per year

    // Group by indicatorGroup
    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.indicatorGroup]) {
            acc[item.indicatorGroup] = [];
        }
        acc[item.indicatorGroup].push(item);
        return acc;
    }, {});









    // Modal edit/update indicator targets data handler to fetch latest targets for update
    const handleOpenModal = async () => {
        try {
            const res = await api.get('/api/logframe/getTargetsForUpdate');
            setModalData(res.data);

            // Initialize editable copy
            const initialEdit = {};
            res.data.forEach(item => {
                initialEdit[item.indicator_key] = { ...item.yearlyTargets };
            });

            setEditedData(initialEdit);
            setShowModal(true);

        } catch (err) {
            console.error(err);
        }
    };

    const handleInputChange = (indicator_key, year, value) => {
        setEditedData(prev => ({
            ...prev,
            [indicator_key]: {
                ...prev[indicator_key],
                [year]: value
            }
        }));
        setHasChanges(true); // Mark that there are unsaved changes when user edits any input
    };

    //cancel button handler to close modal and reset edited data
    const handleCancel = () => {
        setShowModal(false);
        setEditedData({});
        setHasChanges(false); // Reset unsaved changes flag when canceling
    };


    //Save Button handler to update indicator targets data for each project year and fetch latest targets for update
    const handleSave = async () => {
        try {
            const updates = [];
            const sessionUser = JSON.parse(sessionStorage.getItem("user"));

            //Convert edited data → API format
            Object.keys(editedData).forEach(indicator_key => {
                const yearsObj = editedData[indicator_key];

                Object.keys(yearsObj).forEach(year => {
                    updates.push({
                        indicator_key,
                        year: parseInt(year),
                        target_value: Number(yearsObj[year]),
                        updated_by: sessionUser.username
                    });
                });
            });

            await api.post('/api/logframe/updateTargets', { updates });

            alert('Indicator targets has been saved successfully');

            setShowModal(false);
            setHasChanges(false); // Reset unsaved changes flag after saving
            fetchData(); // refresh main table

        } catch (err) {
            console.error(err);
            alert('Error saving data');
        }
    };

    const handleCloseModal = () => {
        if (hasChanges) {
            const confirmClose = window.confirm(
                'You have unsaved changes. Are you sure you want to close?'
            );

            if (!confirmClose) return;
        }

        setShowModal(false);
        setEditedData({});
        setHasChanges(false);
    };



    const groupedByIndicatorGroup = modalData.reduce((acc, item) => {
        if (!acc[item.indicator_group]) {
            acc[item.indicator_group] = [];
        }
        acc[item.indicator_group].push(item);
        return acc;
    }, {});
    //End Modal edit/update indicator targets data handler to fetch latest targets for update







    //Modal edit/update metadata handler for baseline, mid-term, end target for update
    const handleOpenMetaModal = async () => {
        try {
            const res = await api.get('/api/logframe/getMetaForUpdate');
            setMetaData(res.data);

            const initialEdit = {};
            res.data.forEach(item => {
                initialEdit[item.indicator_key] = {
                    baseline: item.baseline ?? '',
                    mid_term: item.mid_term ?? '',
                    end_target: item.end_target ?? ''
                };
            });

            setEditedMeta(initialEdit);
            setShowMetaModal(true);

        } catch (err) {
            console.error(err);
        }
    };

    const handleMetaChange = (key, field, value) => {
        setEditedMeta(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                [field]: value
            }
        }));
        setHasMetaChanges(true);
    };

    const handleSaveMeta = async () => {
        try {
            const updates = Object.keys(editedMeta).map(key => ({
                indicator_key: key,
                baseline: Number(editedMeta[key].baseline || 0),
                mid_term: Number(editedMeta[key].mid_term || 0),
                end_target: Number(editedMeta[key].end_target || 0)
            }));

            await api.post('/api/logframe/updateMetaTargets', { updates });

            alert('Baseline, Mid-Term, and End Target has been saved successfully');

            setShowMetaModal(false);
            setHasMetaChanges(false);
            fetchData();

        } catch (err) {
            console.error(err);
            alert('Error saving data');
        }
    };

    const handleCloseMetaModal = () => {
        if (hasMetaChanges) {
            const confirmClose = window.confirm(
                'You have unsaved changes. Are you sure you want to close?'
            );
            if (!confirmClose) return;
        }

        setShowMetaModal(false);
        setEditedMeta({});
        setHasMetaChanges(false);
    };

    const groupedMeta = metaData.reduce((acc, item) => {
        if (!acc[item.indicator_group]) {
            acc[item.indicator_group] = [];
        }
        acc[item.indicator_group].push(item);
        return acc;
    }, {});

    //End Modal edit/update metadata handler for baseline, mid-term, end target for update




    // Modal edit/update questionnaire results handler for each year for update
    const handleOpenQuestionnaireModal = async () => {
        try {
            const res = await api.get('/api/logframe/getQuestionnaireForUpdate');
            setQuestionnaireData(res.data);

            const initialEdit = {};
            res.data.forEach(item => {
                initialEdit[item.indicator_key] = { ...item.yearlyResults };
            });

            setEditedQuestionnaire(initialEdit);
            setShowQuestionnaireModal(true);

        } catch (err) {
            console.error(err);
        }
    };

    const handleQuestionnaireChange = (key, year, value) => {
        setEditedQuestionnaire(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                [year]: value
            }
        }));
        setHasQuestionnaireChanges(true);
    };

    const handleSaveQuestionnaire = async () => {
        try {
            const updates = [];
            const sessionUser = JSON.parse(sessionStorage.getItem("user"));

            Object.keys(editedQuestionnaire).forEach(key => {
                Object.keys(editedQuestionnaire[key]).forEach(year => {
                    updates.push({
                        indicator_key: key,
                        year: parseInt(year),
                        result_value: Number(editedQuestionnaire[key][year] || 0),
                        updated_by: sessionUser.username
                    });
                });
            });

            await api.post('/api/logframe/updateQuestionnaire', { updates });

            alert('Questionnaire results has been saved successfully');

            setShowQuestionnaireModal(false);
            setHasQuestionnaireChanges(false);
            fetchData();

        } catch (err) {
            console.error(err);
            alert('Error saving questionnaire');
        }
    };

    const handleCloseQuestionnaireModal = () => {
        if (hasQuestionnaireChanges) {
            const confirmClose = window.confirm(
                'You have unsaved changes. Are you sure you want to close?'
            );

            if (!confirmClose) return;
        }

        setShowQuestionnaireModal(false);
        setEditedQuestionnaire({});
        setHasQuestionnaireChanges(false);
    };

    const groupedQuestionnaireModal = questionnaireData.reduce((acc, item) => {
        if (!acc[item.indicator_group]) {
            acc[item.indicator_group] = [];
        }
        acc[item.indicator_group].push(item);
        return acc;
    }, {});
    // End Modal edit/update questionnaire results handler for each year for update











    //Export logframe data to Excel handler
    const handleExportExcel = async () => {

        try {

            const response = await api.get(
                '/api/logframe/exportExcel',
                {
                    responseType: 'blob'
                }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement('a');

            link.href = url;

            link.setAttribute(
                'download',
                'logframe_report.xlsx'
            );

            document.body.appendChild(link);

            link.click();

            link.remove();

        } catch (err) {

            console.error(err);

            alert('Failed to export Excel');

        }
    };
    //End Export logframe data to Excel handler









    return (

        <div className="container-fluid p-1">
            <h4 className="mb-1">📈 Logical Framework Update</h4>
            {/* Buttons */}
            <div className="d-flex justify-content-between mb-2">
                {/* Check if ADMIN then show logframe data update and export option action buttons */}
                <div className="d-flex align-items-center flex-wrap">
                    {hasRole("ADMIN") && (
                        <>
                            <button className='btn btn-primary btn-sm me-2' style={{ width: '170px' }} onClick={handleOpenMetaModal} title='To update baseline, mid-term, and end targets'> Update baseline target</button>
                            <button className='btn btn-primary btn-sm me-2' style={{ width: '170px' }} onClick={handleOpenModal} title='To update yearly indicator targets for each project year' >Update yearly target</button>
                            <button className='btn btn-primary btn-sm me-2' style={{ width: '170px' }} onClick={handleOpenQuestionnaireModal} title='To update questionnaire results' >Update questionnaires</button>
                        </>
                    )}
                    {/* Check if Not ADMIN then only show logframe data export action buttons */}
                    <button className='btn btn-primary btn-sm' style={{ width: '170px' }} onClick={handleExportExcel} title='To download the logframe report' >Export logframe report</button>
                </div>
            </div>

            <div>
                <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 320px)' }}>
                    <table bordered hover className=" align-middle table table-sm table-bordered table-hover fs-7">
                        <thead className=" sticky-header-log-for-frame text-center align-middle">
                            <tr className='table-success'>
                                <th rowSpan="3" className='row-header-sticky-col-1'>Results Hierarchy</th>
                                <th rowSpan="3" className='row-header-sticky-col-2'>Indicator</th>
                                <th rowSpan="3" className='row-header-sticky-col-3'>Baseline</th>
                                <th rowSpan="3" className='row-header-sticky-col-4'>Mid-Term</th>
                                <th rowSpan="3" className='row-header-sticky-col-5'>End Target</th>

                                {/* Map column head by exact year*/}
                                {/* {years.map((year, index) => (
                                    <th key={`main-${year}-${index}`} colSpan="3" className="table-success" style={{ zIndex: 1 }}> Project Yr {index + 1}</th>
                                ))} */}

                                {/* Mapp column head manual as user request to have some current and new data column head to compare */}
                                {years.map((year, index) => {
                                    let label = `Project Yr ${index + 1}`;

                                    // Append custom suffixes for specific columns
                                    // if (index === 1) label += ' (Current)';
                                    // if (index === 2) label = 'Project Yr 2 (Updated)'; // Keep number same
                                    // if (index >= 3) label = `Project Yr ${index}`; // Shift subsequent years back by 1

                                    return (
                                        <th
                                            key={`main-${year}-${index}`}
                                            colSpan="3"
                                            className="table-success"
                                            style={{ zIndex: 1 }}
                                        >
                                            {label}
                                        </th>
                                    );
                                })}


                            </tr>
                            <tr>
                                {years.map((year) => (
                                    <th key={`yr-${year}`} colSpan="3" className="table-success">{year}</th>
                                ))}
                            </tr>
                            <tr>
                                {years.map((year) => (
                                    <React.Fragment key={`sub-${year}`}>
                                        <th className="table-info">Target</th>
                                        <th className="table-primary">Result</th>
                                        <th className="table-warning">Cumulative</th>
                                    </React.Fragment>
                                ))}
                            </tr>
                        </thead>



                        <tbody>
                            {Object.entries(groupedData).map(([groupTitle, rows], groupIndex) => (
                                <React.Fragment key={`group-${groupIndex}`}>
                                    <tr className="table-secondary fw-bold text-start">
                                        {/* <td colSpan={totalColumns}>Output: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {groupTitle}</td> */}
                                        <td colSpan={totalColumns}>
                                            <span style={{ display: 'inline-block', width: '120px' }}>
                                                {groupIndicatorLabelMap[groupIndex] || ''}
                                            </span>
                                            {groupTitle}
                                        </td>
                                    </tr>

                                    {rows.map((row, rowIndex) => (

                                        <tr key={`row-${groupIndex}-${rowIndex}`}>

                                            {/* Render the 'hierarchy' cell only for the first row in the group */}
                                            {rowIndex === 0 && (<td rowSpan={rows.length} className='row-header-sticky-col-1'>{row.hierarchy}</td>)}

                                            <td className='row-header-sticky-col-2 text-start'>{row.indicator}</td>
                                            <td className='row-header-sticky-col-3'>{row.baseline.toLocaleString()}</td>
                                            <td className='row-header-sticky-col-4'>{row.midTerm.toLocaleString()}</td>
                                            <td className='row-header-sticky-col-5'>{row.endTarget.toLocaleString()}</td>

                                            {years.map((year) => (
                                                <React.Fragment key={`data-${rowIndex}-${year}`}>
                                                    <td className="table-info">{(row.yearlyData[year]?.target.toLocaleString() ?? '-')}</td>
                                                    <td className="table-danger">{row.yearlyData[year]?.result.toLocaleString() ?? '-'}</td>
                                                    <td className="table-warning">{row.yearlyData[year]?.cumulative.toLocaleString() ?? '-'}</td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>






            {/* Show Modal for indicator targets update/edit */}
            {/* <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="custom-modal-width" > */}
            <Modal show={showModal} onHide={handleCloseModal} dialogClassName="custom-modal-width" >
                <Modal.Header closeButton style={{ backgroundColor: '#7de2d1' }}>
                    <Modal.Title>Update Target Values</Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-1">
                    <div className="modal-table-wrapper">
                        <Table bordered size="sm" className="mb-0 text-center modal-table">
                            <thead >
                                <tr>
                                    <th>Hierarchy</th>
                                    <th>Indicator</th>
                                    {years.map(year => (
                                        <th key={year}>{year}</th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {Object.entries(groupedByIndicatorGroup).map(
                                    ([groupName, groupRows], groupIndex) => {

                                        // Group by hierarchy inside each group
                                        const hierarchyGroups = groupRows.reduce((acc, item) => {
                                            if (!acc[item.hierarchy]) {
                                                acc[item.hierarchy] = [];
                                            }
                                            acc[item.hierarchy].push(item);
                                            return acc;
                                        }, {});

                                        return (
                                            <React.Fragment key={groupIndex}>

                                                {/* ✅ Indicator Group Row */}
                                                <tr className="table-secondary fw-bold">
                                                    <td colSpan={2 + years.length} className="text-start">
                                                        {/* Output: {groupName} */}
                                                        {groupName}
                                                    </td>
                                                </tr>

                                                {/* ✅ Hierarchy + Indicators */}
                                                {Object.entries(hierarchyGroups).map(
                                                    ([hierarchy, rows], hIndex) => (
                                                        <React.Fragment key={hIndex}>
                                                            {rows.map((row, rowIndex) => (
                                                                <tr key={`${groupIndex}-${hIndex}-${rowIndex}`}>

                                                                    {/* ✅ Merge hierarchy */}
                                                                    {rowIndex === 0 && (
                                                                        <td rowSpan={rows.length} className="col-hierarchy">
                                                                            {/* {hierarchy ?? ''} */}
                                                                            {hierarchy === 'null' || hierarchy === null ? '' : hierarchy}
                                                                        </td>
                                                                    )}

                                                                    <td className="col-indicator">{row.indicator}</td>

                                                                    {years.map(year => (
                                                                        <td key={year}>
                                                                            <Form.Control
                                                                                type="number"
                                                                                size="sm"
                                                                                value={
                                                                                    editedData[row.indicator_key]?.[year] ?? ''
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleInputChange(
                                                                                        row.indicator_key,
                                                                                        year,
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))}
                                                        </React.Fragment>
                                                    )
                                                )}
                                            </React.Fragment>
                                        );
                                    }
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>




                <Modal.Footer>
                    {/* <Button variant="secondary" onClick={handleCancel}> */}
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>









            {/* Show new logframe modal metadata edit/updates for baseline / mid-term / end target */}
            <Modal show={showMetaModal} onHide={handleCloseMetaModal} dialogClassName="custom-modal-width">
                <Modal.Header closeButton style={{ backgroundColor: '#7de2d1' }}>
                    <Modal.Title>Update Baseline / Mid-Term / End Target</Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-1">
                    <div className="modal-table-wrapper">
                        <Table bordered size="sm" className="mb-0 text-center modal-table">
                            <thead>
                                <tr>
                                    <th>Hierarchy</th>
                                    <th>Indicator</th>
                                    <th>Baseline</th>
                                    <th>Mid-Term</th>
                                    <th>End Target</th>
                                </tr>
                            </thead>

                            <tbody>
                                {Object.entries(groupedMeta).map(([groupName, groupRows], gIndex) => {

                                    const hierarchyGroups = groupRows.reduce((acc, item) => {
                                        if (!acc[item.hierarchy]) acc[item.hierarchy] = [];
                                        acc[item.hierarchy].push(item);
                                        return acc;
                                    }, {});

                                    return (
                                        <React.Fragment key={gIndex}>

                                            <tr className="table-secondary fw-bold">
                                                <td colSpan={5} className="text-start">
                                                    {groupName}
                                                </td>
                                            </tr>

                                            {Object.entries(hierarchyGroups).map(([hierarchy, rows], hIndex) => (
                                                <React.Fragment key={hIndex}>
                                                    {rows.map((row, rIndex) => (
                                                        <tr key={`${gIndex}-${hIndex}-${rIndex}`}>

                                                            {rIndex === 0 && (
                                                                <td rowSpan={rows.length} className="col-hierarchy">
                                                                    {/* {hierarchy || ''} */}
                                                                    {hierarchy === 'null' || hierarchy === null ? '' : hierarchy}
                                                                </td>
                                                            )}

                                                            <td className="text-start">{row.indicator}</td>

                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={editedMeta[row.indicator_key]?.baseline ?? ''}
                                                                    onChange={(e) =>
                                                                        handleMetaChange(row.indicator_key, 'baseline', e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={editedMeta[row.indicator_key]?.mid_term ?? ''}
                                                                    onChange={(e) =>
                                                                        handleMetaChange(row.indicator_key, 'mid_term', e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    size="sm"
                                                                    value={editedMeta[row.indicator_key]?.end_target ?? ''}
                                                                    onChange={(e) =>
                                                                        handleMetaChange(row.indicator_key, 'end_target', e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseMetaModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSaveMeta}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>









            {/* Show new logframe modal edit/updates for questionnaires result for each years */}
            <Modal show={showQuestionnaireModal} onHide={handleCloseQuestionnaireModal} dialogClassName="custom-modal-width">
                <Modal.Header closeButton style={{ backgroundColor: '#7de2d1' }}>
                    <Modal.Title>Update Questionnaire Results</Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-1">
                    <div className="modal-table-wrapper">
                        <Table bordered size="sm" className="mb-0 text-center modal-table">
                            <thead>
                                <tr>
                                    <th>Hierarchy</th>
                                    <th>Indicator</th>
                                    {years.map(year => (
                                        <th key={year}>{year}</th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {Object.entries(groupedQuestionnaireModal).map(([groupName, groupRows], gIndex) => {

                                    const hierarchyGroups = groupRows.reduce((acc, item) => {
                                        if (!acc[item.hierarchy]) acc[item.hierarchy] = [];
                                        acc[item.hierarchy].push(item);
                                        return acc;
                                    }, {});

                                    return (
                                        <React.Fragment key={gIndex}>

                                            <tr className="table-secondary fw-bold">
                                                <td colSpan={2 + years.length} className="text-start">
                                                    {groupName}
                                                </td>
                                            </tr>

                                            {Object.entries(hierarchyGroups).map(([hierarchy, rows], hIndex) => (
                                                <React.Fragment key={hIndex}>
                                                    {rows.map((row, rIndex) => (
                                                        <tr key={`${gIndex}-${hIndex}-${rIndex}`}>

                                                            {rIndex === 0 && (
                                                                <td rowSpan={rows.length} className="col-hierarchy">
                                                                    {hierarchy === 'null' || hierarchy === null ? '' : hierarchy}
                                                                </td>
                                                            )}

                                                            <td className="text-start">{row.indicator}</td>

                                                            {years.map(year => (
                                                                <td key={year}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        size="sm"
                                                                        value={
                                                                            editedQuestionnaire[row.indicator_key]?.[year] ?? ''
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleQuestionnaireChange(
                                                                                row.indicator_key,
                                                                                year,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            ))}

                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseQuestionnaireModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSaveQuestionnaire}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>







        </div>





    );
}
